GatiServerGame = function () {
  GatiServer.call(this);
  this.inFS = false;
  this.fsIndex = 0;
  this.fsWinnings = 0;
  this.numFsRemaining = 0;
  this.fsCount = 0;
  // NEW RESTORE GOLDEN BET BEFORE RESTORE IS SHOWN
  // we dont need to replace this now
  // this.restorePreviousWagersBase = this.restorePreviousWagers;
  // this.restorePreviousWagers = this.restorePreviousWagersDerived;
  this._inEncore = false;
  this._inBuyABonus = false;
  this._rtp = 0;
  this._baseGameWinnings = 0;

  this.freeSpinsCostMultiplier;

  this._inLuckyBet = false;

  this._finalBaseWinnings = 0;
  this._finalFsWinnings = 0;

  //	this._coinValue = 100; // because of paytable

  this._baseOutcome = {
    spins: [],
  };

  // this.loadLanguageFiles = undefined; // delete me when translations are ready

  this.force = undefined;

  this.prepaidInitialBalance = 0;
  this.prepaidResultBalance = 0;
};

GatiServerGame.prototype = Object.create(GatiServer.prototype);
GatiServerGame.prototype.constructor = GatiServerGame;

GatiServerGame.prototype.initServer = function (cb) {
  this.init(
    function () {
      cb();
    },
    function () {},
    'ReflexGaming',
    'LEFT_CENTER',
    [],
    'TOP_LEFT'
  );
};

GatiServerGame.prototype.getSupplierForceName = function () {
  return 'gati_' + +this._rtp * 1000;
};

GatiServerGame.prototype.updateCurrentStake = function (newStake) {
  if (this._stake != newStake) {
    let isStakeLower = newStake < this._stake;
    this._stake = newStake;
    this._slotGame.getGameEventsEmitter().totalBetChanged(this._stake / 100);

    let sc = resourceManager.getController('stakeController');
    if (sc.isMaxStake() && !this._inReplayMode && !this._inRewatchMode && !this._isPrePaidGame && !isStakeLower) {
      this._slotGame.uiComponents().clickActionHandler();
    }
  }
};

GatiServerGame.prototype.setBPL = function (bpl) {
  let baseStake = this._numLines * bpl;
  let newStake = baseStake;
  if (gameData.encoreEnabled) {
    newStake *= Globals.GB_MULTIPLIER;
  }

  this.updateCurrentStake(newStake);
};

// GatiServerGame.prototype.restorePreviousWagersDerived = function () {
//   let res = this.restorePreviousWagersBase();

//   if (
//     this._previousWagers &&
//     this._previousWagers.data &&
//     this._previousWagers.data.length > 0 &&
//     this._previousWagers.data[0].bets &&
//     this._previousWagers.data[0].bets.length > 0 &&
//     this._previousWagers.data[0].bets[0].betdata.cmd === 'LUCKYBET_BUY'
//   ) {
//     // res.baseStake *= 10; // coin for lucky bet is 10x bigger
//     this.setDefaultBet(res.baseStake);
//   }
//   return res;
// };

GatiServerGame.prototype.addGameConfigToQueue = function (loadData) {
  this.cheatPanelActive = loadData.customParameters.cheatPanel === 'yes';

  if (this._inReplayMode === true && this._slotGame.getWagerHelper().getPrepaidInfo().isPrepaid === true) {
    this.prepaidInitialBalance = parseFloat(loadData.wagers.data[0].bets[0].betdata.initialBalance) * 100;
    this.prepaidResultBalance = parseFloat(loadData.wagers.data[0].bets[0].eventdata.resultBalance) * 100;
  }

  GatiServer.prototype.addGameConfigToQueue.call(this, loadData);

  let message = this._messageQueue[0];
  message.buyBonusCost = 100;

  const buyBonusAllowed = !!(
    message.slotConfig.gameModes['BONUS_BUY'] &&
    message.slotConfig.gameModes['BONUS_BUY'].coinSizes.length > 0 &&
    this._buyBonusAllowed === true
  );
  // this
  this._buyBonusAllowed = buyBonusAllowed;
  gdk.addConfigValue('AllowBuyBonus', this._buyBonusAllowed);

  gameData.license = loadData.customParameters.license ?? 'default';

  message.maxExposure = loadData.settings.slotConfig.MaxExposure;

  message.slotConfig.coins = 10; // purely paytable

  this._rtp = message.slotConfig.rtp;

  // this._gambleChances = [];
  // this._gambleChances.push(message.slotConfig.gambleConfig.x3Chance / message.slotConfig.gambleConfig.x3Denominator);
  // this._gambleChances.push(message.slotConfig.gambleConfig.x4Chance / message.slotConfig.gambleConfig.x4Denominator);
  // this._gambleChances.push(-1); // should never be used but stops array failing

  // message.gambleChances7To10 = this._gambleChances[0];
  // message.gambleChances10To13 = this._gambleChances[1];

  gameData.recoveryStake = undefined;
  if (loadData.wagers.data.length) {
    let betData = loadData.wagers.data[0].bets[0].betdata;
    let stake = Number(betData.coin * 1000);
    gameData.recoveryStake = stake;
    if (betData.cmd === 'LUCKYBET_BUY') {
      gameData.recoveryStake *= Globals.GB_MULTIPLIER;
    }
  }

  let stopDistances2 = [0, 2, 5, 8, 11];
  let stopDistances2and5 = [3, 7, 11, 15, 19];
  let stopDistances3 = [11, 15, 19, 23, 27];
  let stopDistances5 = [24, 32, 40, 48, 56];
  switch (this._license) {
    case 'uk':
      message.stopDistances = stopDistances2and5;
      break;
    case 'UKGCRtsTest':
      message.stopDistances = stopDistances2and5;
      break;
    case 'bgc':
      message.stopDistances = stopDistances2and5;
      break;
    case 'es':
      message.stopDistances = stopDistances3;
      break;
    case 'se':
      message.stopDistances = stopDistances3;
      break;
    case 'dk':
      message.stopDistances = stopDistances3;
      break;
    case 'cz':
      message.stopDistances = stopDistances2and5;
      break;
    case 'co':
      message.stopDistances = stopDistances3;
      break;
    case 'agcc':
      message.stopDistances = stopDistances2and5;
      break;
    case 'de':
      message.stopDistances = stopDistances5;
      break;
    default:
      message.stopDistances = stopDistances2;
      break;
  }
};

// NEW RESTORE GOLDEN BET BEFORE RESTORE IS SHOWN
GatiServerGame.prototype.restorePreviousGameModeData = function () {
  const _latestEngineReponse = { wager: this._previousWagers.data[0] };
  for (let i = 0; i < _latestEngineReponse.wager.bets.length; ++i) {
    let bet = _latestEngineReponse.wager.bets[i];
    if (bet.betdata.cmd === 'LUCKYBET_BUY') {
      this._inEncore = true;
      this._inLuckyBet = true;
      this._meta = {
        name: 'encore',
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === 'BONUS_BUY') {
      this._inBuyABonus = true;
      this._meta = {
        name: 'buyABonus',
        value: true,
      };
      break;
    }
  }
  GatiServer.prototype.restorePreviousGameModeData.call(this);
};

GatiServerGame.prototype.addRecoveryToQueue = function () {
  for (let i = 0; i < this._latestEngineReponse.wager.bets.length; ++i) {
    let bet = this._latestEngineReponse.wager.bets[i];
    if (bet.betdata.cmd === 'LUCKYBET_BUY') {
      this._inLuckyBet = true;
      this._inEncore = true;
      this._meta = {
        name: 'encore',
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === 'BONUS_BUY') {
      this._inBuyABonus = true;
      this._meta = {
        name: 'buyABonus',
        value: true,
      };
      break;
    }
  }
  GatiServer.prototype.addRecoveryToQueue.call(this);
};

GatiServerGame.prototype.startGame = function (stakeData, cb) {
  this._inLuckyBet = stakeData.metaData.encore;
  this._inBuyABonus = stakeData.metaData.buyABonus;

  if (this._forces === undefined || !this._forces) {
    this._forces = '';
    this.addCheatToRequest(stakeData, this._forces);
  }

  GatiServer.prototype.startGame.call(this, stakeData, cb);
};

GatiServerGame.prototype.addMetaDataToSpinRequest = function (request) {
  this._coinValue = 10;
  let stakeController = resourceManager.getController('stakeController');
  let baseStake = stakeController.getBaseStake('default') / 100;

  if (this._forces === '' && this.cheatPanelActive) {
    request.cheat = JSON.stringify(null);
  }

  request.coin = request.amount / this._coinValue;
  request.coins = this._coinValue;

  if (this._inLuckyBet) {
    // this._coinValue = 10; // has to be whole number
    request.amount = baseStake * Globals.GB_MULTIPLIER;
    request.coin = baseStake / this._coinValue;
    request.cmd = 'LUCKYBET_BUY';
  } else if (this._inBuyABonus) {
    baseStake = stakeController.getBaseStake('BONUS_BUY') / 100;
    request.amount = baseStake * 100;
    request.coin = baseStake / this._coinValue;
    request.cmd = 'BONUS_BUY';
  }
};

GatiServerGame.prototype.convertResultsPanelToSymbols = function (resultsPanel, blockDistribution) {
  // this basically converts the array of objects to an array
  const mappedResultsPanel = resultsPanel.map(function (reel, index) {
    return reel.symbols.map(function (curr) {
      return curr.value;
    });
  });

  // now pass this new array
  const symbols = Utils.shrinkArrayBasedOnBlockDistribution(mappedResultsPanel, blockDistribution);
  return symbols;
};

GatiServerGame.prototype.createWinsOnGigabloxAnalysis = function (gigabloxLayout, winEvent) {
  const winsOnGigabloxAnalysis = Utils.fillArray([], 0, 5); // 3 to 5 ofak

  for (let i = 0; i < winEvent.winningLines.length; ++i) {
    const numGlobalReelsCovered = winEvent.winningLines[i].positions.length;
    const numLocalReelsCovered = this.convertGlobalToLocal(gigabloxLayout, numGlobalReelsCovered - 1);
    for (let j = 0; j <= numLocalReelsCovered; ++j) {
      winsOnGigabloxAnalysis[j]++;
    }
  }

  return winsOnGigabloxAnalysis;
};

GatiServerGame.prototype.convertGlobalToLocal = function (linkedReels, globalReelId) {
  for (let i = 0; i < linkedReels.length; ++i) {
    if (linkedReels[i].indexOf(globalReelId) !== -1) {
      return i;
    }
  }
  return -1;
};

GatiServerGame.prototype.buildGigabloxData = function (data, spinEvent, triggeringFreeSpins) {
  // used passed in data until we no longer need to send it for the original reels
  const aboveData = this.calcSymbolsAbove(data);
  const below = Utils.calcSymbolsBelow({
    symbolsAbove: aboveData.above,
    blockDistribution: data.blockDistribution,
    board: data.respins[0].spinToBoard,
    fillEmptyGaps: true,
    disableBonusTease:
      triggeringFreeSpins || this.inFS || (data.goldenClawModifier && data.goldenClawModifier.isAwarded),
  });

  // whats our max width symbol? 1, 2 or 3? 0 should that determine the amount of prefill?
  const preApp = Globals.NUM_PRE_APPERATURE_SYMBOLS;
  const widths = data.blockDistribution.split('-').map(Number);

  let reelIndex = 0;
  const above = aboveData.above;
  for (let w = 0; w < widths.length; w++) {
    const width = widths[w];
    while (above[reelIndex].length < preApp) {
      const amountToAdd = width;
      const symbolIndexesForAbove = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].filter((x) => !above[reelIndex].includes(x));
      const randomId = symbolIndexesForAbove[Utils.randomNumberBetween(0, symbolIndexesForAbove.length - 1)];

      for (let k = 0; k < width; k++) {
        for (let i = 0; i < amountToAdd; i++) {
          // we need to update both reels at same time if width > 1
          above[reelIndex + k].push(randomId);
        }
      }
    }
    reelIndex += width;
  }

  const trimmedAbove = [];
  for (let i = 0; i < above.length; i++) {
    trimmedAbove[i] = above[i].slice(0);
  }

  // all above should now have enough or too much
  reelIndex = 0;
  for (let w = 0; w < widths.length; w++) {
    const width = widths[w];

    // if i was a cleverer man, i wouldnt need this bit :P
    // if we are > Globals.NUM_PRE_APPERATURE_SYMBOLS, lets remove the 1st couple to get it back to Globals.NUM_PRE_APPERATURE_SYMBOLS
    for (let k = 0; k < width; k++) {
      const amountToRemove = trimmedAbove[reelIndex + k].length - preApp;
      for (let i = 0; i < amountToRemove; i++) {
        trimmedAbove[reelIndex + k].pop();
      }
      trimmedAbove[reelIndex + k].reverse();
    }
    reelIndex += width;
  }

  // now we need to remove Globals.NUM_PRE_APPERATURE_SYMBOLS from start of array
  reelIndex = 0;
  for (let w = 0; w < widths.length; w++) {
    const width = widths[w];

    for (let k = 0; k < width; k++) {
      for (let i = 0; i < Globals.NUM_PRE_APPERATURE_SYMBOLS; i++) {
        above[reelIndex + k].shift();
      }
    }
    reelIndex += width;
  }

  const gigabloxLayout = Utils.convertBlockDistributionToGigabloxLayout(data.blockDistribution);
  const gigabloxData = {
    gigabloxLayout: gigabloxLayout,
    symbols: this.convertResultsPanelToSymbols(spinEvent.resultsPanel.reelList, data.blockDistribution),
    above: Utils.shrinkArrayBasedOnBlockDistribution(trimmedAbove, data.blockDistribution),
    below: Utils.shrinkArrayBasedOnBlockDistribution(below, data.blockDistribution),
    winsOnGigabloxAnalysis: this.createWinsOnGigabloxAnalysis(gigabloxLayout, spinEvent.winningLineEvent),
    remainingAbove: above,
  };
  return gigabloxData;
};

GatiServerGame.prototype.getSpinDataNormal = function (data, triggeringFreeSpins) {
  let spinEvent = data.respins[0];

  if (!this.validateResponse(spinEvent)) return;

  spinEvent.resultsPanel = {};
  spinEvent.resultsPanel.reelList = spinEvent.spinToBoard.stopWindow.reelList;

  // before paw slap modifier - broadcast the blockDistribution
  // may not need this now
  const blockDistMessage = {};
  blockDistMessage.type = 'game:blockDistribution';
  blockDistMessage.blockDistribution = data.blockDistribution; // i think this is the only thing i need to send
  blockDistMessage.gigabloxLayout = Utils.convertBlockDistributionToGigabloxLayout(data.blockDistribution);
  this._messageQueue.push(blockDistMessage);

  // before reels stop
  if (data.pawSlapModifier.isAwarded === true) {
    const message = {};
    message.type = 'game:pawSlapModifier';
    message.modifierData = data.pawSlapModifier;
    this._messageQueue.push(message);
  }

  this.addSpinDataToQueue(spinEvent);

  const spinMessage = this._messageQueue[this._messageQueue.length - 1];
  spinMessage.blockDistribution = data.blockDistribution;
  spinMessage.lastRespin = data.respins[data.respins.length - 1];
  spinMessage.gigablox = this.buildGigabloxData(data, spinEvent, triggeringFreeSpins);
  spinMessage.winCapped = data.winCapped;

  // after reels have stopped and before wins
  // are processed
  if (data.champagneModifier.isAwarded === true) {
    const champMessage = {};
    champMessage.type = 'game:champagneModifier';
    champMessage.modifierData = data.champagneModifier;
    spinMessage.champagneModifierData = data.champagneModifier;
    champMessage.blockDistribution = data.blockDistribution;
    this._messageQueue.push(champMessage);
  }
  if (data.goldenClawModifier.isAwarded === true) {
    const clawMessage = {};
    clawMessage.type = 'game:goldenClawModifier';
    clawMessage.modifierData = data.goldenClawModifier;
    clawMessage.blockDistribution = data.blockDistribution;
    this._messageQueue.push(clawMessage);
  }

  let totalWinInBase = 0;

  // we need to make sure the last pop message is sent, as this
  // contains all the win info which goes over the max win
  const respinLimitAdjustment = data.winCapped ? 0 : 1;

  for (let i = 0; i < data.respins.length - respinLimitAdjustment; ++i) {
    // never used anywhere - let finalPop = i == data.respins.length - 2;
    totalWinInBase += data.respins[i].winAmount;

    const allWinningLineEvent = JSON.parse(JSON.stringify(data.respins[i].winningLineEvent));

    // set up the pops and drops
    if (allWinningLineEvent.winningLines.length > 0) {
      this.addPopsToQueue(
        allWinningLineEvent,
        data.respins[i].multiplier,
        data.respins[i].winAmountBeforeMultiplier,
        data.respins[i].winAmount,
        data.respins[i].winCapped
      );

      if (data.respins[i].winCapped !== true) {
        // if we are capped, there is nothing to drop in
        // can we add some above data in this message?
        this.addDropsToQueue(
          data.respins[i + 1].payBoard.stopWindow.reelList,
          data.respins[i + 1].wildAddedResult.coordsAdded,
          data.respins[i + 1].winningBlocksRemoved.coordsRemoved,
          false,
          false,
          false,
          false,
          false, // finalPop - never used in the game,
          data.respins[i + 1].kind,
          data.respins[i + 1].payBoard.columns,
          data.respins[i + 1].payBoard,
          data.respins[i + 1].winCapped,
          spinMessage.gigablox.remainingAbove
        );
      }
    }
  }

  this.addPopDropsOverToQueue(totalWinInBase, triggeringFreeSpins, data.winCapped);

  return totalWinInBase;
};

GatiServerGame.prototype.calcSymbolsAbove = function (data) {
  const symbolConfig = resourceManager.getConfiguration().symbols;
  const blankID = symbolConfig['Blank'].ID;
  const bonusID = symbolConfig['Bonus'].ID;
  const above = [];
  const shiftRequired = [];
  const widths = data.blockDistribution.split('-').map(Number);

  for (let i = 0; i < Globals.NUM_REELS; i++) {
    above[i] = [];
    shiftRequired[i] = 0;
  }

  // lets 1st look at blockDistribution and colossal symbols
  // overhanging the top
  const respins = data.respins;
  const spinToBoard = respins[0].spinToBoard;
  let reelIndex = 0;
  for (let i = 0; i < widths.length; i++) {
    const column = spinToBoard.columns[i];
    const width = widths[i];

    for (let j = 0; j < width; j++) {
      const reelList = spinToBoard.stopWindow.reelList[reelIndex];
      if (width > 1) {
        const height = column.rows[0].height;
        if (height === 1) {
          // this means we have bonus symbols across the top
          // leave the code below to work out whats going to drop in?
          // random or from wins
        } else {
          if (column.shift === 0) {
            // this means we have a perfect symbol at the top,
            // leave the code below to work out whats going to drop in
            // random or from wins
          } else {
            // this means the symbol is overhanging
            // so we need to duplicate whats at the top of the window
            // how many should we add?
            const symbolID = reelList.symbols[0].value;
            if (width === 3) {
              shiftRequired[reelIndex] = column.shift === 1 ? 2 : 1;
            } else {
              shiftRequired[reelIndex] = column.shift;
            }
            for (let k = 0; k < column.shift; k++) {
              above[reelIndex].push(symbolID);
            }
          }
        }
      }

      reelIndex++;
    }
  }

  // now lets go and fill in whats above based on if there is a win
  for (let i = 1; i < respins.length; i++) {
    const respin = respins[i];

    // we need to go through all respins and look for a blank on all reels at any point
    // this is because you can get bonus symbols added in later
    // so its not just a case of looking at the 1st win
    const reelList = respin.droppedBoard.stopWindow.reelList;
    const payBoard = respin.payBoard.stopWindow.reelList;
    for (let reel = 0; reel < reelList.length; reel++) {
      for (let row = reelList[reel].symbols.length - 1; row >= 0; row--) {
        if (reelList[reel].symbols[row].value == blankID) {
          const symbol = payBoard[reel].symbols[row].value;
          if (!Utils.isArray(above[reel])) {
            above[reel] = [];
          }
          above[reel].push(symbol);
        }
      }
    }
  }

  // wont work as this doesnt contain everything from above
  // now we should i think fix the array and make sure we have clumps of 3 if its a 3x3
  reelIndex = 0;
  for (let i = 0; i < widths.length; i++) {
    const width = widths[i];

    if (width > 1) {
      for (let k = 0; k < width; k++) {
        // we dont always want to group the numbers!!!
        // but we cant pass that info in to groupSymbols
        above[reelIndex + k] = Utils.groupSymbols(above[reelIndex + k], width);
        // so we can just remove 1st elements
        for (let j = 0; j < shiftRequired[reelIndex + k]; j++) {
          above[reelIndex + k].shift();
        }
      }
    }
    reelIndex += width;
  }

  // now look for empty gaps
  reelIndex = 0;
  const allowedSymbols = Globals.ALLOWED_SYMBOLS.slice(0);
  const allowedSymbolsWithBonus = allowedSymbols.concat([bonusID]);
  for (let i = 0; i < widths.length; i++) {
    // only add 1 random if its empty
    const width = widths[i];
    if (above[reelIndex].length === 0) {
      let allowedSymbolsToUse = allowedSymbolsWithBonus;
      const reelList = spinToBoard.stopWindow.reelList[reelIndex];

      if (this.inFS || (data.goldenClawModifier && data.goldenClawModifier.isAwarded)) {
        // dont tease bonus symbols if golden claw
        allowedSymbolsToUse = allowedSymbols;
      } else {
        // 11 should only be allowed if we dont have one on the reels already!
        // lets look on this reel to see if a bonus symbol is already on the reels
        for (let s = 0; s < reelList.symbols.length; s++) {
          if (reelList.symbols[s].value === bonusID) {
            // bonus already on the reels, cant tease 1 above
            // use the other array
            allowedSymbolsToUse = allowedSymbols;
            break;
          }
        }
      }

      const randomId = allowedSymbolsToUse[Utils.randomNumberBetween(0, allowedSymbolsToUse.length - 1)];
      for (let j = 0; j < width; j++) {
        // can only add 1 lot of bonus ids
        const amountToAdd = randomId !== bonusID ? width : 1;
        for (let k = 0; k < amountToAdd; k++) {
          // above[reelIndex].unshift(randomId);
          above[reelIndex + j].push(randomId);
        }
      }
    }
    reelIndex += width;
  }

  const aboveData = {
    above: above,
  };

  return aboveData;
};

GatiServerGame.prototype.getCheatString = function () {
  return this.force;
};

GatiServerGame.prototype.logCheatString = function () {
  this.force = this._latestEngineReponse.wager.bets[0].eventdata.response.clientData.Repro;

  if (this.force !== '') {
    console.log('force: ' + this.force);
  }
};

GatiServerGame.prototype.addCheatToRequest = function (request, forces) {
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) return;

  request.cheat = forces;
  this.cheatAdded = true;
};

GatiServerGame.prototype.updateForces = function (forces) {
  if (!forces) return undefined;
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) return;

  return forcesJson;
};

GatiServerGame.prototype.addMultiplerToQueue = function (multiplier) {
  var message = {};
  message.type = 'tiki_runner:MultiplierEvent';
  message.currentMultiplier = multiplier; //1 + Math.floor(this.gameOutcome.numSpins / message.totalSteps);
  message.nextMultiplier = multiplier * 2; //message.currentMultiplier + 1;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.getSpinDataFS = function (cb) {
  let data = this.freeSpins[this.fsCount++];
  --this.numFsRemaining;

  let spinEvent = data.respins[0];

  spinEvent.resultsPanel = {};
  spinEvent.resultsPanel.reelList = spinEvent.spinToBoard.stopWindow.reelList;

  // paw slap modifier wont occur in free spins

  // before paw slap modifier - broadcast the blockDistribution
  // this might not be needed now?
  const blockDistMessage = {};
  blockDistMessage.type = 'game:blockDistribution';
  blockDistMessage.blockDistribution = data.blockDistribution; // i think this is the only thing i need to send
  blockDistMessage.gigabloxLayout = Utils.convertBlockDistributionToGigabloxLayout(data.blockDistribution);
  this._messageQueue.push(blockDistMessage);

  this.addSpinDataToQueue(spinEvent);

  const message = this._messageQueue[this._messageQueue.length - 1];
  message.blockDistribution = data.blockDistribution;
  message.lastRespin = data.respins[data.respins.length - 1];
  message.gigablox = this.buildGigabloxData(data, spinEvent, true);
  message.winCapped = data.winCapped;

  if (data.champagneModifier.isAwarded === true) {
    let champMessage = {};
    champMessage.type = 'game:champagneModifier';
    champMessage.modifierData = data.champagneModifier;
    message.champagneModifierData = data.champagneModifier;
    champMessage.blockDistribution = data.blockDistribution;
    this._messageQueue.push(champMessage);
  }

  // golden claw wont occur in free spins

  // Check for Mystery/Sticky Wilds
  this.stickyWilds = {};
  data.respins.forEach((reel) => {
    reel.mysteryWildWon = false;
    reel.stickyWildWon = false;
    reel.stickyWilds = { ...this.stickyWilds };
    // reel.wildPositions.forEach((coord) => {
    //   if (coord.kind === 5) reel.mysteryWildWon = true;
    //   else if (coord.kind === 4) {
    //     this.stickyWilds[`${coord.coord.reel},${coord.coord.offset}`] = true;
    //     reel.stickyWildWon = true;
    //   }
    // });
  });

  // we need to make sure the last pop message is sent, as this
  // contains all the win info which goes over the max win
  const respinLimitAdjustment = data.winCapped ? 0 : 1;

  let spinWin = 0;
  for (let i = 0; i < data.respins.length - respinLimitAdjustment; ++i) {
    // never used anywhere let finalPop = i == data.respins.length - 2;
    spinWin += data.respins[i].winAmount;

    const allWinningLineEvent = JSON.parse(JSON.stringify(data.respins[i].winningLineEvent));

    // set up the pops and drops
    if (allWinningLineEvent.winningLines.length > 0) {
      this.addPopsToQueue(
        allWinningLineEvent,
        data.respins[i].multiplier,
        data.respins[i].winAmountBeforeMultiplier,
        data.respins[i].winAmount,
        data.respins[i].winCapped
      );
      // ???
      // if (!data.cascades[i + 1].wildPositions) {
      //   data.cascades[i + 1].wildPositions = [];
      // }
      if (data.respins[i].winCapped !== true) {
        this.addDropsToQueue(
          data.respins[i + 1].payBoard.stopWindow.reelList,
          data.respins[i + 1].wildAddedResult.coordsAdded,
          data.respins[i + 1].winningBlocksRemoved.coordsRemoved,
          false,
          false,
          false,
          false,
          false, //finalPop,
          data.respins[i + 1].kind,
          data.respins[i + 1].payBoard.columns,
          data.respins[i + 1].payBoard,
          data.respins[i + 1].winCapped,
          message.gigablox.remainingAbove
        );
      }
    }
  }

  this.fsWinnings += spinWin;
  this.addPopDropsOverToQueue(spinWin, undefined, data.winCapped);

  if (this.fsCount < this.freeSpins.length) {
    this.addFSDataToQueue();
  } else {
    this.addFSEndToQueue();
    this.addGameCompleteToQueue(this._totalWinnings);
    this.inFS = false;
    this.numFsRemaining = 0;
  }

  cb();
  this.triggerNextMessage();
};

GatiServerGame.prototype.sendGambleResponseToServer = function (numScatters, response, cb) {
  if (this._gameNotFullyRecovered) {
    // no need to send state, already done and part of recovery
    this.moveToNextBetData();
    messageBus.postImmediate('Gamble:HandledCommand');
    timerManager.addTimer(500, undefined, cb);
    return;
  }

  this.resetCurrentBetData();

  let self = this;
  let decision = response === 'collect' ? 'COLLECT' : 'RISK';
  let nextStep = self._latestEngineReponse.wager.bets[self._latestEngineReponse.wager.bets.length - 1].step + 1;

  let preFix = 'GAMBLE_Basic_';
  if (this._inBuyABonus) {
    preFix = 'GAMBLE_BonusBuy_';
  } else if (this._inLuckyBet) {
    preFix = 'GAMBLE_LuckyBet_';
  }

  let playData = {
    cmd: preFix + decision + '_' + numScatters,
    step: nextStep,
    clientParams: '',
  };

  const sendCommand = async () => {
    self._latestEngineReponse = await self._slotGame.play(playData);
    self._forces = self.updateForces(self._forces);
    cb();
  };
  sendCommand();
};

GatiServerGame.prototype.addFSAwardToQueue = function (data) {
  let numFS = [Globals.THREE_SCATTERS_AWARD, Globals.FOUR_SCATTERS_AWARD, Globals.FIVE_SCATTERS_AWARD];
  let numScatters = data.scatterCount;

  var message = {};
  message.type = 'tiki_runner:FreeSpinsAwardEvent';
  message.freeSpinsAwarded = numFS[numScatters - 3];
  message.possibleValues = numFS;
  message.numScatters = numScatters;
  message.nextFreespins = numFS[numScatters - 2];
  message.winChance = this._gambleChances[numScatters - 3]; // reads these from game config event.
  message.buyABonus = this._inBuyABonus;
  let self = this;
  message.resultCallback = function (obj, cb) {
    self.sendGambleResponseToServer(numScatters, obj.response, cb);
  };

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addGambleResultToQueue = function (won) {
  var message = {};
  message.type = 'fire_gems:GambleResultEvent';
  message.won = won;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.getSpinData = function (cb, data) {
  if (this.inFS) {
    this.getSpinDataFS(cb, data);
    return;
  }

  this._forces = '';

  gameController.rng().seed(data.ResultId);

  let parts = data.Parts;

  let totalWon = 0;
  let triggeringFreeSpins = false;
  for (let i = 0; i < parts.length; ++i) {
    let type = parts[i].type;
    if (type === 'baseGame') {
      this._finalBaseWinnings = parts[0].winAmount;
      triggeringFreeSpins = parts[1]?.type === 'freeSpins';
      totalWon += this.getSpinDataNormal(parts[i], triggeringFreeSpins);
      // base game only, game complete
      if (parts.length === 1) {
        this.addGameCompleteToQueue(totalWon);
      }
    } else if (type === 'gambleEntered') {
      // if (parts[i].scatterCount >= 5) {
      //   // nothing to gamble for
      //   this.addFSAwardToQueue(parts[i]);
      //   this.inGamble = true;
      // } else {
      //   this.addFSAwardToQueue(parts[i]);
      //   this.inGamble = true;
      // }
    } else if (type === 'gambleResult') {
      // let won = parts[i].hasWon;
      // this.addGambleResultToQueue(won);
      // if (!won) {
      //   this.inGamble = false;
      //   this.addGameCompleteToQueue(totalWon);
      // }
    } else if (type === 'freeSpins') {
      this.inGamble = false;
      this.inFS = true;
      this.fsCount = 0;
      this.freeSpins = parts[i].spins;
      let numFS = [7, 10, 12];
      this._finalFsWinnings = data.Parts[1].winAmount;
      this._totalWinnings = this._finalBaseWinnings + this._finalFsWinnings;
      this.addFSStartToQueue(numFS[parts[i].scatterCount - 3]);
    }
  }

  cb();
  this.triggerNextMessage();
};

GatiServerGame.prototype.addPopsToQueue = function (
  winningsLinesMessage,
  multiplier,
  unMultiplied,
  multiplied,
  winCapped
) {
  var message = winningsLinesMessage;
  message.type = 'spinner:WinningLinesEvent';
  message.multiplier = multiplier;
  message.winCapped = winCapped;

  message.totalLineWinnings = multiplied; //this.gameOutcome.outcomeWinnings;
  message.totalLineWinningsNonMultiplied = unMultiplied;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addDropsToQueue = function (
  serverWindow,
  wildCells,
  poppedSymbols,
  mysteryWildWon,
  stickyWildWon,
  stickyZoneActiveAtStart,
  stickyZoneActiveAtEnd,
  finalPop,
  kind,
  columnInfo,
  board,
  winCapped,
  aboveAfter
) {
  var message = {};

  var popWindow = [
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
  ];
  // var newWildsWindow = [
  //   [-1, -1, -1, -1, -1],
  //   [-1, -1, -1, -1, -1],
  //   [-1, -1, -1, -1, -1],
  //   [-1, -1, -1, -1, -1],
  //   [-1, -1, -1, -1, -1],
  // ];

  let newPoppedList = poppedSymbols.filter((cell) => {
    popWindow[cell.reel][cell.row] = -1;
    return true;
  });

  while (poppedSymbols.length > newPoppedList.length) {
    poppedSymbols.pop();
  }
  for (let i = 0; i < newPoppedList.length; i++) {
    poppedSymbols[i] = newPoppedList[i];
  }

  if (kind === 4) {
    this.adjustPopWindowForGoldenClawModifier(popWindow, columnInfo);
  }

  for (let i = 0; i < wildCells.length; ++i) {
    let wildCell = wildCells[i];
    if (popWindow[wildCell.reel][wildCell.row] === -1) {
      // symbol was going to pop as part of a win, but
      // it looks like we are adding a wild there
      // so dont pop it as a normal symbol, gameController will know how to pop
      // also store the fact its that type of wild
      wildCell.replacingAPoppedSymbol = true;
      popWindow[wildCell.reel][wildCell.row] = 0;
    }
  }

  let newWindow = [];
  for (let i = 0; i < serverWindow.length; ++i) {
    let slot = [];
    let serverSlot = serverWindow[i].symbols;
    for (j = 0; j < serverSlot.length; ++j) {
      slot.push({ _id: serverSlot[j].value });
      // if (newWildsWindow[i][j] === -2) newWildsWindow[i][j] = serverSlot[j].value;
    }
    newWindow.push(slot);
  }

  message.type = 'tiki_runner:DropEvent';
  message.tumbleData = popWindow;
  message.window = newWindow;
  message.cells = wildCells;
  message.stickyWildWon = false;
  message.stickyZoneActiveAtStart = false;
  message.stickyZoneActiveAtEnd = false;
  message.finalPop = finalPop;
  message.kind = kind;
  message.board = board;
  message.winCapped = winCapped;
  message.aboveAfter = aboveAfter;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.adjustPopWindowForGoldenClawModifier = function (popWindow, columnInfo) {
  const reelIndexMapping = [
    null, // 0
    [
      [0, 1, 2, 3, 4], // 0
    ], // size 1
    [
      [2, 0, 1, 3, 4], // 0
      [0, 3, 1, 2, 4], // 1
      [0, 1, 4, 2, 3], // 2
    ], // size 2
    [
      [3, 0, 1, 2, 4], // 0
      [0, 4, 1, 2, 3], // 1
    ], // size 3
  ];

  let foundIndex = -1;
  let foundSize = -1;
  for (let c = 0; c < columnInfo.length; c++) {
    if (columnInfo[c].standardSize !== 1) {
      foundIndex = c;
      foundSize = columnInfo[c].standardSize;
      break;
    }
  }

  if (foundIndex !== -1) {
    let reelMapping = reelIndexMapping[foundSize][foundIndex - 1];
    const origPopWindow = JSON.parse(JSON.stringify(popWindow));
    for (let i = 0; i < popWindow.length; i++) {
      const origReelIndex = i;
      const newReelIndex = reelMapping[origReelIndex];
      for (let j = 0; j < popWindow[i].length; j++) {
        popWindow[origReelIndex][j] = origPopWindow[newReelIndex][j];
      }
    }
  }
};

GatiServerGame.prototype.addPopDropsOverToQueue = function (winnings, triggeringFreeSpins, winCapped) {
  var message = {};
  message.type = 'tiki_runner:PopAndDropComplete';
  message.winnings = winnings;
  message.winCapped = winCapped;
  message.triggeringFreeSpins = triggeringFreeSpins;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSStartToQueue = function (numFs) {
  this.fsWinnings = 0;

  this.numFsRemaining = numFs;

  var message = {};
  message.type = 'tiki_runner:FreeSpinsStartEvent';
  message.freeSpinsAwarded = numFs;
  message.bonuswin = 0;
  message.currentMultiplier = 1;
  message.nextMultiplier = 2;
  this.inGamble = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSDataToQueue = function () {
  var message = {};
  message.type = 'tiki_runner:FreeSpinsDataEvent';
  message.num = this.numFsRemaining;
  message.fsWinnings = this.fsWinnings;
  this._messageQueue.push(message);
};
GatiServerGame.prototype.addFSEndToQueue = function () {
  var message = {};
  message.type = 'tiki_runner:FreeSpinsEndEvent';
  message.totalWinnings = this._totalWinnings;
  message.fsWinnings = this.fsWinnings + this._baseGameWinnings;
  this.fsWinnings = 0;
  this.inFS = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.endGame = async function (cb) {
  this._endGame = true;
  await this.doEndGame(cb);
  this._endGame = false;
};
